export default __webpack_public_path__ + "static/media/vacuum-cleaner.59981b7e.jpeg";